import mixpanel from "mixpanel-browser";
export const initializeMixpanel = () => {
  mixpanel.init(process.env.MIXPANEL_TOKEN || "", {
    debug: process.env.NODE_ENV !== "production", //disables logs
    track_pageview: false,
    persistence: "localStorage",
  });
};
initializeMixpanel();

export const mixpanelTrack = (type: any, body: any = {}) => {
  try {
    if (typeof window !== "undefined") {
      mixpanel?.track?.(type, {
        ...body,
        Platform: "Web",
      });
    }
  } catch (e) {
    console.error("Mixpanel track error", e);
  }
};

export const setSuperMixpanelProperty = async (
  phone: any,
  type: any,
  data: any
) => {
  let x: { [key: string]: string } = {};
  x[`$${type}`] = data;
  mixpanel.identify(phone);
  mixpanel.people.set(x);
};

export const identiyMixpanelUser = async (user: any) => {
  try {
    const distinctId = await mixpanel.get_distinct_id();
    mixpanel.identify(user.phone);
    mixpanel.people.set_once(distinctId, {
      $user_id: user?.phone,
    });
  } catch (error) {
    console.error("Error", error);
  }
};

export const mixpanelLogOut = (body: any = {}) => {
  mixpanel.track("Logout", {
    ...body,
    Platform: "Web",
  });
  mixpanel.reset();
};
